import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import RequestForSignetApprovalProcessingView from '../RequestForSignetApproval/ProcessingView.js/RequestForSignetApprovalProcessingView';

class ModalForPreviewRequestApproval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: '',

      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { t } = this.props || {},
      { Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        centered
        className="wide-modal"
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h3 className="title text-center">{Labels.title}</h3>
            <div className="row">
              <RequestForSignetApprovalProcessingView
                isPreview={true}
                id={this.props.id}
              />
            </div>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForPreviewRequestApproval,
  'ModalForPreviewRequestApproval'
);
